var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "email-templates" }, [
    !_vm.editMode
      ? _c(
          "div",
          [
            _c("div", { staticClass: "toolbar-container" }, [
              _c(
                "div",
                { staticClass: "left-section" },
                [
                  _c("EmailTemplateFilterToolbar", {
                    ref: "filterToolbar",
                    model: {
                      value: _vm.filters,
                      callback: function ($$v) {
                        _vm.filters = $$v
                      },
                      expression: "filters",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "right-section" },
                [
                  _c(
                    "SupsisButton",
                    {
                      attrs: { primary: "", small: "" },
                      on: { click: _vm.openCreateTemplateModal },
                    },
                    [_vm._v("Yeni Şablon")]
                  ),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("supsis-table", {
              attrs: {
                columns: _vm.columns,
                rows: _vm.templates,
                "bottom-pagination": true,
                "pagination-cursor": _vm.paginationCursor,
              },
              on: { "cursor-changed": _vm.onCursorChanged },
            }),
            _vm._v(" "),
            _vm.showCreateTemplateModal
              ? _c(
                  "Modal2",
                  {
                    on: {
                      cancel: _vm.closeCreateTemplateModal,
                      ok: _vm.createTemplate,
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "title",
                          fn: function () {
                            return [_vm._v("Yeni E-posta Şablonu Oluştur")]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      4129477128
                    ),
                  },
                  [
                    _vm._v(" "),
                    _c("CreateEmailTemplateForm", {
                      ref: "createTemplateForm",
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        )
      : _c(
          "div",
          [
            _c("EmailTemplateEditor", {
              attrs: { template: _vm.selectedTemplate },
              on: {
                close: function ($event) {
                  _vm.editMode = false
                },
                "template-updated": _vm.onTemplateUpdated,
              },
            }),
          ],
          1
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }